import { PopoverDesignTokens } from '@primeuix/themes/types/popover';
import { colors } from '../colors';

export const popover: PopoverDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        background: colors.blue500,
      },
    },
  },
};
